module.exports = __webpack_public_path__ + "static/media/product1.861a2dc1.png";